import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaArrowUp, FaDownload } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import NavbarMenu from "../heroSection/NavbarMenu";
import Footer from "../footer/Footer";
import "./DriverTerms.css";
import SEO from "../SEO";

export default function CopyRigtht() {
  const { t } = useTranslation();
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    AOS.init({ once: true, duration: 1000, offset: 120 });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <SEO
        title="TransCirox – Urheberrechte | Copyright"
        description="Urheber- und Nutzungsrechte der TransCiroX GmbH. Alle Inhalte der Website, mobilen Anwendungen und Plattform sind urheberrechtlich geschützt."
        keywords="Urheberrecht, Copyright, Nutzungsrechte, TransCiroX, Schutzrechte"
      />
      <NavbarMenu />

      <section className="driver-terms-page mt-5 px-5">
        <Container>
          <div className="terms-card">
            {/* Header */}
            <div className="terms-header">
              <button className="back-btn" onClick={() => window.history.back()}>
                <FaArrowLeft />
              </button>
              <div>
                <h2>{t("copyright.hero.title")}</h2>
              </div>
            </div>

            {/* Scroll Content */}
            <div className="terms-scroll">
              <div className="document">
                <h1>
                  {t("copyright.mainTitle")}
                  <br />
                  {/* {t("copyright.subtitle")} */}
                </h1>

                {/* Company */}
                <h3>{t("copyright.company_name")}</h3>

                {/* Content 1 */}
                <p>{t("copyright.content_1")}</p>

                {/* Content 2 */}
                <p>{t("copyright.content_2")}</p>

                {/* Prohibited Actions */}
                <h3>{t("copyright.prohibited_title")}</h3>
                <p>{t("copyright.prohibited_intro")}</p>
                <ul>
                  <li>{t("copyright.prohibited.l1")}</li>
                  <li>{t("copyright.prohibited.l2")}</li>
                  <li>{t("copyright.prohibited.l3")}</li>
                  <li>{t("copyright.prohibited.l4")}</li>
                  <li>{t("copyright.prohibited.l5")}</li>
                  <li>{t("copyright.prohibited.l6")}</li>
                </ul>

                {/* Consequences */}
                <p>{t("copyright.consequences")}</p>

                {/* Footer */}
                <p><strong>{t("copyright.all_rights_reserved")}</strong></p>

                <div className="document-meta">
                  <p>{t("copyright.last_updated")}</p>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* Back to top button */}
      {showScrollTop && (
        <button
          className="back-to-top"
          onClick={scrollToTop}
          aria-label="Back to top"
        >
          <FaArrowUp />
        </button>
      )}

      <Footer />
    </>
  );
}